import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Products from './Products';
import AddProduct from './AddProduct';
import Inventory from './Inventory';
import Customers from './Customers';
import EmiDashboard from './EmiDashboard';
import CustomerDetail from './CustomerDetail';
import ProductDetail from './ProductDetail';
import EmiDetail from './EmiDetail';
import NotificationHistory from './NotificationHistory';
import LoanManagement from './LoanManagement';
import LoanDetailPage from './LoanDetailPage';
import LoanEMIDashboard from './LoanEMIDashboard';
import LoanAnalysis from './LoanAnalysis';
import FeaturedProducts from './FeaturedProducts';
import HeroCarousel from './HeroCarousel';
import ProductRequests from './ProductRequests';
import CustomerFeedbackDashboard from './CustomerFeedbackDashboard';
import WhatsAppInboxDashboard from './WhatsAppInboxDashboard';
import SocialMediaDashboard from './SocialMediaDashboard';
import BuybackCampaign from './BuybackCampaign';
import RepairsDashboard from './RepairsDashboard';
import RepairBusinessAnalysis from './RepairBusinessAnalysis';
import PawnDashboard from './PawnDashboard';
import PawnBusinessAnalysis from './PawnBusinessAnalysis';

const AdminDashboard = () => {
  return (
    <div className="admin-dashboard">
      <Routes>
        <Route path="/" element={<Navigate to="/products" replace />} />
        <Route path="/products" element={<Products />} />
        <Route path="/add-product" element={<AddProduct />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customer/:id" element={<CustomerDetail />} />
        <Route path="/emi-dashboard" element={<EmiDashboard />} />
        <Route path="/emi/:id" element={<EmiDetail />} />
        <Route path="/customer-settings/:id" element={<CustomerDetail />} />
        <Route path="/notification-history" element={<NotificationHistory />} />
        <Route path="/loan-management" element={<LoanManagement />} />
        <Route path="/loan/:id" element={<LoanDetailPage />} />
        <Route path="/loan-emi-dashboard" element={<LoanEMIDashboard />} />
        <Route path="/loan-analysis" element={<LoanAnalysis />} />
        <Route path="/featured-products" element={<FeaturedProducts />} />
        <Route path="/hero-carousel" element={<HeroCarousel />} />
        <Route path="/product-requests" element={<ProductRequests />} />
        <Route path="/customer-feedback" element={<CustomerFeedbackDashboard />} />
        <Route path="/whatsapp-inbox" element={<WhatsAppInboxDashboard />} />
        <Route path="/social-media" element={<SocialMediaDashboard />} />
        <Route path="/buyback-campaign" element={<BuybackCampaign />} />
        <Route path="/repairs" element={<RepairsDashboard />} />
        <Route path="/repair-analysis" element={<RepairBusinessAnalysis />} />
        <Route path="/pawn" element={<PawnDashboard />} />
        <Route path="/pawn-analysis" element={<PawnBusinessAnalysis />} />
      </Routes>
    </div>
  );
};

export default AdminDashboard;
